export default "__VITE_ASSET__ozLD5uqH__"